import { styleBouton } from './styles.js';

/**
 * Installation de l’application (PWA). Le manifeste et le bouton « Installer » vivent ici ; le service worker et la
 * stratégie de cache sont à L22 (`src/sw/**`), et le branchement dans `index.html` / `public/` à O1 (RFC-050).
 */
export const TITRE_DOCUMENT = 'Cabinet MAAT · Votre espace succession';
export const DESCRIPTION_DOCUMENT = 'Votre espace de suivi de succession, proposé par le Cabinet MAAT.';

export interface IconeManifeste {
  src: string;
  sizes: string;
  type: 'image/png';
  purpose: 'any' | 'maskable';
}

export interface Manifeste {
  id: string;
  name: string;
  short_name: string;
  description: string;
  lang: 'fr';
  dir: 'ltr';
  display: 'standalone';
  start_url: string;
  scope: string;
  theme_color: string;
  background_color: string;
  icons: IconeManifeste[];
}

export const MANIFESTE: Manifeste = {
  id: '/',
  name: 'Lakou · Cabinet MAAT',
  short_name: 'Lakou',
  description: DESCRIPTION_DOCUMENT,
  lang: 'fr',
  dir: 'ltr',
  display: 'standalone',
  start_url: '/',
  scope: '/',
  theme_color: '#383D6C',
  background_color: '#FFFFFF',
  icons: [
    { src: '/icones/lakou-192.png', sizes: '192x192', type: 'image/png', purpose: 'any' },
    { src: '/icones/lakou-512.png', sizes: '512x512', type: 'image/png', purpose: 'any' },
    { src: '/icones/lakou-512-maskable.png', sizes: '512x512', type: 'image/png', purpose: 'maskable' },
  ],
};

export const genererManifesteJson = (): string => JSON.stringify(MANIFESTE, null, 2);

export type EtatInstallation = 'indisponible' | 'disponible' | 'installee';
export type EvenementInstallation = { type: 'proposee' } | { type: 'installee' } | { type: 'refusee' };

export const ETAT_INSTALLATION_INITIAL: EtatInstallation = 'indisponible';

export function reducerInstallation(etat: EtatInstallation, evenement: EvenementInstallation): EtatInstallation {
  if (etat === 'installee') return etat;
  if (evenement.type === 'proposee') return 'disponible';
  return evenement.type === 'installee' ? 'installee' : 'indisponible';
}

/** Forme minimale de l’événement `beforeinstallprompt` des navigateurs. */
export interface InvitationInstallation {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export async function lancerInstallation(invitation: InvitationInstallation | null): Promise<EtatInstallation> {
  if (!invitation) return 'indisponible';
  await invitation.prompt();
  const { outcome } = await invitation.userChoice;
  return outcome === 'accepted' ? 'installee' : 'indisponible';
}

export function BoutonInstaller({ etat, onInstaller }: { etat: EtatInstallation; onInstaller: () => void }) {
  if (etat !== 'disponible') return null;
  return (
    <button type="button" onClick={onInstaller} style={styleBouton}>
      Installer Lakou sur cet appareil
    </button>
  );
}
